<button
  [type]="htmlType"
  [class]="getButtonClasses() + getSizeClasses()"
  [disabled]="disabled || loading"
  (click)="handleClick()"
>
  <!-- Loading Spinner -->
  <span
    *ngIf="shouldShowSpinner()"
    nz-icon
    nzType="loading"
    class="animate-spin text-white"
  ></span>

  <!-- Left Icon -->
  <span
    *ngIf="shouldShowIcon() && iconPosition === 'left'"
    nz-icon
    [nzType]="icon"
    [class]="getIconClasses()"
  ></span>

  <!-- Button Label -->
  <span [class]="getLabelClasses()">{{ label }}</span>

  <!-- Right Icon -->
  <span
    *ngIf="shouldShowIcon() && iconPosition === 'right'"
    nz-icon
    [nzType]="icon"
    [class]="getIconClasses()"
  ></span>
</button>
